import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, Subject } from 'rxjs';
import { GeographicalRegion, GeographicalRegionService, PermissionsEnum, PermissionsService, SubGeographicalRegion, SubGeographicalRegionService } from 'shared-lib';
import { KycSubServiceType } from 'src/app/_modules/customers/_models/kyc-account-data';
import { Area } from 'src/app/models/area.model';
import { ChecklistItem } from 'src/app/models/checklist-item.model';
import { InstallationAndPowerSource, SortByOptions } from 'src/app/models/customer.model';
import { Region } from 'src/app/models/region.model';
import { ProjectType } from 'src/app/models/serviceConnection.model';
import { SiteVerificationList, SiteVerificationsStats, SiteVerificationStatus } from 'src/app/models/siteVerification.model';
import { AreaService } from 'src/app/services/area.service';
import { AuthService } from 'src/app/services/auth.service';
import { CustomerService } from 'src/app/services/customer.service';
import { RegionService } from 'src/app/services/region.service';
import { SiteVerificationService } from 'src/app/services/siteVerification.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-service-order-list',
  templateUrl: './service-order-list.component.html',
  styleUrls: ['./service-order-list.component.scss']
})
export class ServiceOrderListComponent implements OnInit, OnDestroy {
  dateFrom: string;
  dateTo: string;
  mapSortBy: Record<number, any> = {
    [SortByOptions.NEWEST]: { label: 'Newest', arrow: 'no', translation: 'COMMON.SORT_BY.NEWEST' },
    [SortByOptions.OLDEST]: { label: 'Oldest', arrow: 'no', translation: 'COMMON.SORT_BY.OLDEST' },
  };
  sortByValue: SortByOptions = SortByOptions.NEWEST;
  tag?: number;
  tagOptions = [
    { name: 'Existing', value: 0, translation: 'COMMON.TAG.EXISTING' },
    { name: 'New Customer', value: 1, translation: 'COMMON.TAG.ONBOARD' },
  ];
  statusItems = [
    { id: SiteVerificationStatus.New, name: 'New', checked: false },
    { id: SiteVerificationStatus.Assigned, name: 'Assigned', checked: false },
    { id: SiteVerificationStatus.Submited, name: 'Submitted', checked: false },
    { id: SiteVerificationStatus.Approved, name: 'Approved', checked: false },
    { id: SiteVerificationStatus.Rejected, name: 'Rejected', checked: false },
    { id: SiteVerificationStatus.Suspended, name: 'Suspended', checked: false },
  ];
  selectedStatuses: number[] = [];
  showSortBy: boolean = false;
  ddPos = { top: '0px', left: '0px' };

  sltOptions: { id: number, displayValue: string, installationAndPowerSource: number }[] = [];
  selectedSltStatus?: number;
  isSltDropdownDisabled: boolean = false;

  selectedSubserviceType?: number;
  selectedProjectType?: number;
  showSubserviceTypes: boolean = false;
  subServiceTypeOptions: { value: number, displayValue: string }[] = [
    { value: KycSubServiceType.PublicLoad, displayValue: 'Public Load' },
    { value: KycSubServiceType.MeterReplacement, displayValue: 'Meter Replacement' },
    { value: KycSubServiceType.Migration, displayValue: 'Migration' },
    { value: KycSubServiceType.Separation, displayValue: 'Separation' },
    { value: KycSubServiceType.PointLoadTransformer, displayValue: 'Point Load Transformer' },
    { value: KycSubServiceType.DedicatedFeeder, displayValue: 'Dedicated Feeder' },
    { value: KycSubServiceType.NewService, displayValue: 'New Service' },
    { value: KycSubServiceType.UpgradeToKcg, displayValue: 'Upgrade to KCG' },
  ]

  projectTypeOptions: { value: number, displayValue: string }[] = [
    { value: ProjectType.MAP, displayValue: 'MAP' },
    { value: ProjectType.NMAP, displayValue: 'NMAP' },
    { value: ProjectType.KCG, displayValue: 'KCG' }
  ]

  stats: SiteVerificationsStats = {};
  sortByOptions = SortByOptions;
  sortByLabelValue: any = this.mapSortBy[SortByOptions.NEWEST];
  pageSize: number = 10;
  currentPage: number = 1;
  searchText: string = '';
  searchTextUpdate = new Subject<string>();
  searchByOptions = [
    { name: 12, value: 'Application No.', translation: 'COMMON.TABLE_HEADERS.APP_NUM' },
    { name: 1, value: 'Account No.', translation: 'CUSTOMERS.SEARCH_BY.ACCOUNT_NO' },
    { name: 4, value: 'Building Owner', translation: 'CUSTOMERS.SEARCH_BY.BUILDING_OWNER' },
  ];
  showSelectSearchType: boolean = false;
  selectedSearchType: number;
  selectedSearchTypeDisplay: string;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  clicked: boolean = false;
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  selectedFilters: ChecklistItem[] = [];
  siteVerifications: SiteVerificationList[] = [];
  count: number = 0;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  hasCimDataIntegration: boolean = false;
  utilityId: number = 0;
  constructor(
    private toastr: ToastrService,
    private translationService: TranslationService,
    private regionService: RegionService,
    private areaService: AreaService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private siteVerificationService: SiteVerificationService,
    private customerService: CustomerService,
    private router: Router,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    public permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.utilityId = parseInt(localStorage.getItem('utilityId') || '');
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
    this.setFilters();
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getRegions();
      this.getAreas();
    }
    this.getAllSltStatuses();
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((value: any) => {
      if (this.searchText == '') this.search();
    });
    this.selectedSearchType = this.selectedSearchType ?? this.searchByOptions[0].name;
    this.selectedSearchTypeDisplay = this.selectedSearchTypeDisplay ?? this.searchByOptions[0].translation;

    document.addEventListener('scroll', this.onAnyScroll, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.onAnyScroll, true);
  }

  private onAnyScroll = (): void => {
    this.showSelectSearchType = false;
    this.showSortBy = false;
  };
  private getData(): void {
    this.getSiteVerificationStats();
    this.reloadTable();
  }
  getSiteVerificationStats() { }
  selectSearchType(searchType: any) {
    if (this.searchText && this.searchText !== '') {
      this.searchText = '';
      this.search();
    }
    this.selectedSearchType = searchType.name;
    this.selectedSearchTypeDisplay = searchType.translation;
    this.showSelectSearchType = false;
  }
  search() {
    this.createFilterCards();
  }

  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }

  selectTag(e: any) {
    if (e.target.value != '') {
      this.tag = parseInt(e.target.value);
    } else {
      this.tag = undefined;
    }

    this.createFilterCards();
  }

  setFilterStorage() {
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count,
      },
      filterParams: this.getFilterObjectForStorage(),
      utilityId: this.utilityId,
    };

    localStorage.setItem('cameFrom', 'SiteVerification');
    localStorage.setItem('filterSiteVerification', JSON.stringify({ type: 'SiteVerification', filter: obj }));
  }

  removeFilterStorage() {
    if (this.hasCimDataIntegration) {
      if (this.geographicalRegions.length > 0 && this.allSubGeographicalRegions.length > 0)
        localStorage.removeItem('filterSiteVerification');
    } else if (this.allAreas.length > 0 && this.regions.length > 0) {
      localStorage.removeItem('filterSiteVerification');
    }
  }

  getFilterObjectForStorage() {
    let obj = {
      sortBy: this.sortByValue,
      search: this.searchText,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? this.dateTo : null,
      searchType: this.selectedSearchType,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedStatuses: this.selectedStatuses.length > 0 ? this.selectedStatuses : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedSltStatus: this.selectedSltStatus ? this.selectedSltStatus : null,
      selectedSubserviceType: this.selectedSubserviceType ? this.selectedSubserviceType : null,
      tag: this.tag !== undefined ? this.tag : null,
      selectedProjectType: this.selectedProjectType ? this.selectedProjectType : null,
      selectedSubGeographicalIds:
        this.selectedSubGeographicalRegions.length > 0 ? this.selectedSubGeographicalRegions : null,
    };
    return obj;
  }

  setCheckedAreas() {
    var filter = localStorage.getItem('filterSiteVerification');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'SiteVerification') return;
    if (filterObject.filter.filterParams.selectedAreas) {
      this.selectedAreas = filterObject.filter.filterParams.selectedAreas;
      this.areas = this.allAreas.filter((area) =>
        this.regions.some(
          (region) => region.id == area.regionId && region.checked
        )
      );
      this.areas.forEach((element) => {
        if (this.selectedAreas.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setCheckedRegions() {
    var filter = localStorage.getItem('filterSiteVerification');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'SiteVerification') return;
    if (filterObject.filter.filterParams.selectedRegions) {
      this.selectedRegions = filterObject.filter.filterParams.selectedRegions;
      this.regions.forEach((element) => {
        if (this.selectedRegions.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setFilters() {
    var filter = localStorage.getItem('filterSiteVerification');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'SiteVerification') return;
    this.currentPage = filterObject.filter.pageInfo.page;
    this.pageSize = filterObject.filter.pageInfo.pageSize;
    this.count = filterObject.filter.pageInfo.count;
    this.sortByValue = filterObject.filter.filterParams.sortBy;
    this.searchText = filterObject.filter.filterParams.search;
    this.dateFrom = filterObject.filter.filterParams.dateFrom;
    this.dateTo = filterObject.filter.filterParams.dateTo;
    this.selectedSearchType = filterObject.filter.filterParams.searchType;
    this.selectedSearchTypeDisplay =
      this.searchByOptions.find(
        (type) => type.name == filterObject.filter.filterParams.searchType
      )?.translation ?? this.searchByOptions[0].translation;
    this.selectedAreas = filterObject.filter.filterParams.selectedAreas
      ? filterObject.filter.filterParams.selectedAreas
      : [];
    this.selectedRegions = filterObject.filter.filterParams.selectedRegions
      ? filterObject.filter.filterParams.selectedRegions
      : [];
    this.selectedSubGeographicalRegions = filterObject.filter.filterParams.selectedSubGeographicalIds
      ? filterObject.filter.filterParams.selectedSubGeographicalIds
      : [];

    this.sortByLabelValue = this.mapSortBy[this.sortByValue];

    this.selectedSltStatus = filterObject.filter.filterParams.selectedSltStatus
      ? filterObject.filter.filterParams.selectedSltStatus
      : undefined;
    this.selectedSubserviceType = filterObject.filter.filterParams.selectedSubserviceType
      ? filterObject.filter.filterParams.selectedSubserviceType
      : undefined;
    if (filterObject.filter.filterParams.selectedStatuses) {
      this.selectedStatuses = filterObject.filter.filterParams.selectedStatuses;
      this.statusItems.forEach((item) => {
        if (this.selectedStatuses.includes(item.id)) item.checked = true;
      });
    }
    this.tag = filterObject.filter.filterParams.tag !== undefined ? filterObject.filter.filterParams.tag : undefined;
    this.selectedProjectType = filterObject.filter.filterParams.selectedProjectType ? filterObject.filter.filterParams.selectedProjectType : undefined;
  }

  datesValid() {
    if (this.dateFrom && this.dateTo && this.dateTo?.toString() != '') {
      const valid: boolean =
        new Date(this.dateFrom).getTime() <
        new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
      return valid;
    }

    return true;
  }

  selectRegion(e: any) {
  //list of areas for selected regions
    this.areas = this.allAreas.filter(area => this.regions.some(region => region.id == area.regionId && region.checked));
    this.allAreas.forEach(area => {
      if (!this.areas.some(a => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });

    this.createFilterCards();
  }

  private getRoleCapacityRestriction(): InstallationAndPowerSource | null {
    const rolePermissions = localStorage.getItem('permissions');
    const permissions = rolePermissions ? JSON.parse(rolePermissions) : [];
    const hasHigh = permissions.includes(PermissionsEnum.SiteVerification_HighCapacity);
    const hasStandard = permissions.includes(PermissionsEnum.SiteVerification_StandardCapacity);
    if (hasHigh && !hasStandard) return InstallationAndPowerSource.High_Capacity;
    if (!hasHigh && hasStandard) return InstallationAndPowerSource.Standard;
    return null;
  }

  getSltStatusFromRolePermission() {
    const restriction = this.getRoleCapacityRestriction();
    if (restriction == null) return this.selectedSltStatus;
    return this.sltOptions.find(s => s.installationAndPowerSource == restriction)?.id;
  }

  filterSltOptionsByRolePermission(options: typeof this.sltOptions) {
    const restriction = this.getRoleCapacityRestriction();
    if (restriction == null) return options;
    return options.filter(s => s.installationAndPowerSource == restriction);
  }

  getAllSltStatuses() {
    this.customerService.getAllSltStatuses().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sltOptions = responseData.data.map((item: any): any => ({
            id: item.id,
            displayValue: item.value,
            installationAndPowerSource: InstallationAndPowerSource[item.installationAndPowerSource as keyof typeof InstallationAndPowerSource]

          }));
          this.sltOptions = this.filterSltOptionsByRolePermission(this.sltOptions);
          this.selectedSltStatus = this.getSltStatusFromRolePermission();
          this.isSltDropdownDisabled = this.getRoleCapacityRestriction() != null;
          this.getData();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectVerification(id: number) {
    this.router.navigate(
      ['verification-details', id],
      { relativeTo: this.route }
    );    
    this.setFilterStorage();
  }

  private getRegions() {
    this.regionService.getAllAssignedForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.setCheckedRegions();
          this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllAssignedForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.setCheckedAreas();
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response: { body: any; }) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.getSubGeographicalRegions();
        }
      },
      error: (_: any) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response: { body: any; }) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.setCheckedSubGeographical();
          this.createFilterCards();
          this.removeFilterStorage();
        }
      },
      error: (_: any) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private setCheckedSubGeographical() {
    if (!this.selectedSubGeographicalRegions.length) return;
    const parentGeoIds = new Set(
      this.allSubGeographicalRegions
        .filter((s) => this.selectedSubGeographicalRegions.includes(s.id as number))
        .map((s) => s.geographicalRegion.id)
    );
    this.geographicalRegions.forEach((g) => (g.checked = parentGeoIds.has(g.id)));
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((s) =>
      this.geographicalRegions.some((g) => g.id == s.geographicalRegion.id && g.checked)
    );
    this.subGeographicalRegions.forEach(
      (s) => (s.checked = this.selectedSubGeographicalRegions.includes(s.id as number))
    );
  }

  selectGeographicalRegion(e: any) {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
      this.geographicalRegions.some(
        (region) => region.id == sub.geographicalRegion.id && region.checked
      )
    );
    this.allSubGeographicalRegions.forEach((sub) => {
      if (!this.subGeographicalRegions.some((s) => s.id === sub.id)) {
        sub.checked = false;
      }
    });
    this.createFilterCards();
  }

  reloadTable(page: any = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count
      },
      filterParams: this.getFilterObject()
    };
    this.getAll(obj);
  }

  selectArea(e: any) {
    this.createFilterCards();
  }

  selectStatus(e: any) {
    this.createFilterCards();
  }

  selectSltStatus(e: any) {
    if (e.target.value != '') {
      this.selectedSltStatus = e.target.value;
      const isHighCapacity = this.sltOptions.find(s => s.id == this.selectedSltStatus)?.installationAndPowerSource == InstallationAndPowerSource.High_Capacity;
      if (isHighCapacity) {
        this.showSubserviceTypes = true;
      } else {
        this.showSubserviceTypes = false;
        this.selectedSubserviceType = undefined;
      }
    } else {
      this.selectedSltStatus = undefined;
    }
    this.createFilterCards();
  }

  applyFilter(item: ChecklistItem) {
    this.currentPage = 1;
    this.reloadTable(this.currentPage);
  }

  selectSubserviceType(e: any) {
    if (e.target.value != '') {
      this.selectedSubserviceType = e.target.value;
    } else {
      this.selectedSubserviceType = undefined;
    }
    this.createFilterCards();
  }

  selectProjectType(e: any) {
    if (e.target.value != '') {
      this.selectedProjectType = e.target.value;
    } else {
      this.selectedProjectType = undefined;
    }
    
    this.createFilterCards();
  }

  resetFilter() {
    this.selectedFilters = [];
    this.tag = undefined;
    this.regions = this.regions.map(region => ({ ...region, checked: false }));
    this.regions = [...this.regions];

    this.areas = this.areas.map(area => ({ ...area, checked: false }));
    this.areas = [...this.areas];

    this.geographicalRegions = this.geographicalRegions.map(region => ({ ...region, checked: false }));
    this.allSubGeographicalRegions.forEach((sub) => (sub.checked = false));
    this.subGeographicalRegions = [];

    this.statusItems = this.statusItems.map(item => ({ ...item, checked: false }));
    this.statusItems = [...this.statusItems];

    this.selectedStatuses = [];
    this.selectedAreas = [];
    this.selectedRegions = [];
    this.selectedSubGeographicalRegions = [];
    this.selectedSltStatus = undefined;
    this.selectedSubserviceType = undefined;
    this.selectedProjectType = undefined;

    this.searchText = '';
    this.dateFrom = '';
    this.dateTo = '';

    this.reloadTable(1);
  }

  isAllCheckBoxChecked() {
    return false;
  }

  checkAllCheckBox() { }

  getFilterObject() {
    let obj = {
      sortBy: this.sortByValue,
      search: this.searchText,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      statuses: this.selectedStatuses.length > 0 ? this.selectedStatuses : null,
      tag: this.tag,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedSltStatus: this.selectedSltStatus ? Number(this.selectedSltStatus) : null,
      selectedSubserviceType: this.selectedSubserviceType ? Number(this.selectedSubserviceType) : null,
      selectedProjectType: this.selectedProjectType ? Number(this.selectedProjectType) : null,
      selectedSubGeographicalIds:
        this.selectedSubGeographicalRegions.length > 0 ? this.selectedSubGeographicalRegions : null,
      searchType: this.selectedSearchType
    };
    return obj;
  }

  download() {
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count
      },
      filterParams: this.getFilterObject()
    };
    this.siteVerificationService.download(obj).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 'OK' || data?.status === '200') {
          window.location.href = data.data.trim();
        } else if (data?.status === 'Pending' || data?.status === '600') {
          this.toastr.info(data?.message || '');
        } else {
          this.toastr.error(data?.message || 'Request failed');
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  sortBy(option: SortByOptions) {
    this.sortByValue = option;
    this.sortByLabelValue = this.mapSortBy[option];
    this.reloadTable();
  }
  private getAll(obj: any) {

    this.siteVerificationService.getAll(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.siteVerifications = responseData.data.data;
          this.siteVerifications.map(x => x.subserviceType = x.subserviceType.replace(/([a-z])([A-Z])/g, '$1 $2'));
          this.count = responseData.data.count ?? this.count;
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else if (response?.status == 204) {
          this.toastr.warning('No content');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      this.regions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      this.areas.forEach((area) => {
        if (area.name === item.selectedValue) {
          area.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Geographical Region') {
      this.geographicalRegions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.selectGeographicalRegion(item);
      this.clicked = !this.clicked;
    } else if (item.property == 'Sub Geographical Region') {
      this.subGeographicalRegions.forEach((sub) => {
        if (sub.name === item.selectedValue) {
          sub.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Status') {
      this.statusItems.forEach((s) => {
        if (s.name === item.selectedValue) {
          s.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Service Type') {
      this.selectedSltStatus = undefined;
    } else if (item.property == 'Service Request Type') {
      this.selectedSubserviceType = undefined;
    } else if (item.property == 'Search') {
      this.searchText = '';
    } else if (item.property == 'Date From') {
      this.dateFrom = '';
    } else if (item.property == 'Date To') {
      this.dateTo = '';
    } else if (item.property == 'Tag') {
      this.tag = undefined;
    } else if (item.property == 'Project Status') {
      this.selectedProjectType = undefined;
    }

    this.createFilterCards();

    if (this.selectedFilters.length == 0) {
      this.regions.forEach((region) => {
        region.checked = false;
      });
      this.reloadTable(1);
    }
  }

  createFilterCards() {
    this.selectedFilters = [];

    let selectedAreas = this.areas.filter((x) => x.checked);
    let selectedRegions = this.regions.filter((x) => x.checked);
    let selectedGeoRegions = this.geographicalRegions.filter((x) => x.checked);
    let selectedSubGeoRegions = this.subGeographicalRegions.filter((x) => x.checked);
    let selectedStatusItems = this.statusItems.filter((x) => x.checked);
    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedRegions = this.regions.filter((x) => x.checked).map((x) => x.id);
    this.selectedSubGeographicalRegions = selectedSubGeoRegions.map((x) => x.id as number);
    this.selectedStatuses = selectedStatusItems.map((x) => x.id);
    //regions
    for (var i = 0; i < selectedRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(this.buName, selectedRegions[i].name)
      );
    }

    //geographical regions
    for (var i = 0; i < selectedGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Geographical Region',
          selectedGeoRegions[i].name,
          'COMMON.GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //areas
    for (var i = 0; i < selectedAreas.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(this.utName, selectedAreas[i].name)
      );
    }

    //sub geographical regions
    for (var i = 0; i < selectedSubGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Sub Geographical Region',
          selectedSubGeoRegions[i].name,
          'COMMON.SUB_GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //statuses
    for (var i = 0; i < selectedStatusItems.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem('Status', selectedStatusItems[i].name)
      );
    }

    //tag
    if (this.tag || this.tag === 0) {
      var tagName = this.tagOptions[this.tag].name;
      this.selectedFilters.push(new ChecklistItem('Tag', tagName));
    }

    // Service Type
    if (this.selectedSltStatus && !this.isSltDropdownDisabled) {
      var sltStatus = this.sltOptions.find(s => s.id == this.selectedSltStatus);
      if (sltStatus) {
        this.selectedFilters.push(
          new ChecklistItem('Service Type', sltStatus.displayValue)
        );
      }
    }

    //search
    if (this.searchText) {
      this.selectedFilters.push(
        new ChecklistItem('Search', this.searchText, 'COMMON.SEARCH')
      );
    }

    //date from and to
    if (this.dateFrom) {
      this.selectedFilters.push(
        new ChecklistItem('Date From', this.dateFrom.toString(), 'COMMON.DATE_FROM')
      );
    }
    if (this.dateTo) {
      this.selectedFilters.push(
        new ChecklistItem('Date To', this.dateTo.toString(), 'COMMON.DATE_TO')
      );
    }
     
    if (this.selectedSubserviceType) {
      var subServiceType = this.subServiceTypeOptions.find(s => s.value == this.selectedSubserviceType);
      this.selectedFilters.push(
        new ChecklistItem('Service Request Type', subServiceType!.displayValue)
      );
    }

    if (this.selectedProjectType) {
      var projectType = this.projectTypeOptions.find(s => s.value == this.selectedProjectType);
      this.selectedFilters.push(
        new ChecklistItem('Project Status', projectType!.displayValue)
      );
    }
  }

  openDropdown(which: 'st' | 'sb', el: HTMLElement): void {
    const wasOpen = which === 'st' ? this.showSelectSearchType : this.showSortBy;
    this.showSelectSearchType = false;
    this.showSortBy = false;
    if (!wasOpen) {
      if (which === 'st') this.showSelectSearchType = true;
      else this.showSortBy = true;
      const r = el.getBoundingClientRect();
      const zoom = parseFloat((getComputedStyle(document.documentElement) as any).zoom || '1');
      this.ddPos = { top: (r.bottom / zoom) + 'px', left: (r.left / zoom) + 'px' };
    }
  }

  @HostListener('document:click')
  onClickOutside() {
    this.showSelectSearchType = false;
    this.showSortBy = false;
  }
}
